import React from 'react';
import {useIntl} from 'react-intl';
import Styled from 'styled-components';
import {FlexColumn, Tabs} from '@forecast-it/design-system';
import {TopHeaderBar} from '../../shared/components/headers/top-header-bar/TopHeaderBar';
import CustomScrollDiv from '../../shared/components/scroll-bars/custom_scroll_div';
import {ForecastThemeProvider} from '../../shared/ForecastThemeProvider';

const Page = Styled.div`
	padding: 24px 32px;
`;

const BASELINE_TAB = 'baseline';

type Props = {showTabs: boolean; children: React.ReactNode};

/**
 * Admin > Templates, a tabbed shell. Baseline Templates is its only section; another template type
 * is added as its own Tabs.Tab and Tabs.Content, with no placeholder for it until then.
 */
export const TemplatesPage = ({showTabs, children}: Props): JSX.Element => {
	const {formatMessage} = useIntl();
	return (
		<div className="section-content settings-app" data-cy="settings-templates-page">
			<ForecastThemeProvider>
				<CustomScrollDiv>
					<Page>
						<FlexColumn gap="l">
							{showTabs ? (
								<>
									<TopHeaderBar title={formatMessage({id: 'settings.templates.title'})} />
									<Tabs value={BASELINE_TAB} onValueChange={() => undefined}>
										<Tabs.List>
											<Tabs.Tab value={BASELINE_TAB} data-cy="templates-tab-baseline">
												{formatMessage({id: 'baseline_templates.tab.baseline'})}
											</Tabs.Tab>
										</Tabs.List>
										<Tabs.Content value={BASELINE_TAB}>{children}</Tabs.Content>
									</Tabs>
								</>
							) : (
								children
							)}
						</FlexColumn>
					</Page>
				</CustomScrollDiv>
			</ForecastThemeProvider>
		</div>
	);
};
